import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    pagination: {
      page: 0,
      pageSize: 10,
    },
    search: "",
    fullName: "",
    country: { value: "", label: "" },
    city: { value: "", label: "" },
    talentPool: { value: "", label: "" },
    jobsCompleted: "",
    workedWith: "",
    backgroundCheck: "",
    certifications: { value: "", label: "" },
    equipment: { value: "", label: "" },
    skillSet: { value: "", label: "" },
  },
};

const workforceFiltersSlice = createSlice({
  name: "workforceFiltersSlice",
  initialState,
  reducers: {
    setWorkforceFilters: (state, action) => {
      const { filterName, data } = action.payload;
      if (filterName === "pagination") {
        state.value.pagination = { ...state.value.pagination, ...data };
      } else {
        state.value[filterName] = data;
      }
    },
    resetWorkforceFilters: (state) => {
      state.value = { ...initialState.value };
    },
    resetWorkforcePagination: (state) => {
      state.value.pagination = { page: 0, pageSize: 10 };
    },
  },
});

export const {
  setWorkforceFilters,
  resetWorkforceFilters,
  resetWorkforcePagination,
} = workforceFiltersSlice.actions;

export default workforceFiltersSlice.reducer;
